import { TestResponse } from '@rossum/api-client/hooks';
import { FunctionRuntime } from '@rossum/api-client/hooks';
import { Box, Button, useTheme } from '@rossum/ui/material';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { hookInterfacesEnabledSelector } from '../../../redux/modules/organizationGroup/selectors';
import { useProcessIntent } from '../../extension-interop/hooks/useProcessIntent';
import { runtimesConfig } from '../../extensions/Extension/config';
import styles from '../style.module.sass';
import { TabNames } from '../types';

type Props = {
  activeTab: TabNames;
  children?: ReactNode;
  runtime: FunctionRuntime;
  value: TestResponse | undefined;
};

export const ExtensionsOutput = ({
  activeTab,
  children,
  runtime,
  value,
}: Props) => {
  const theme = useTheme();
  const { processIntent } = useProcessIntent();
  const intl = useIntl();
  const commandsEnabled = useSelector(hookInterfacesEnabledSelector);

  return (
    <div className={styles.Box}>
      {children}

      <div
        className={clsx(
          styles.OutputValue,
          theme.palette.mode === 'light' && styles.OutputValueLight
        )}
      >
        {value ? (
          <>
            {'intent' in value.response && commandsEnabled ? (
              <Button
                variant="outlined"
                onClick={() => processIntent(value.response)}
                sx={{ m: 1 }}
              >
                {intl.formatMessage({ id: 'features.extensionInterop.view' })}
              </Button>
            ) : null}
            <Box
              sx={{ color: t => t.palette.text.secondary }}
              className={styles.Preformatted}
            >
              {activeTab === 'response'
                ? JSON.stringify(value.response, undefined, 2)
                : value.log}
            </Box>
          </>
        ) : (
          <Box
            sx={{ color: t => t.palette.text.secondary }}
            className={styles.Preformatted}
          >
            <FormattedMessage
              id={`components.editor.outputBox.empty.${activeTab}.${runtimesConfig[runtime].type}`}
            />
          </Box>
        )}
      </div>
    </div>
  );
};
